'use client';

var maxJobTitleLength = 100;
var duplicatedJobAlert = 6001;
var TOTAL_MAX_JOB_ALERT_CODE = 6002;
var successCode = 200;
var ESalaryPeriod;
(function (ESalaryPeriod) {
    ESalaryPeriod[ESalaryPeriod["MONTHLY"] = 1] = "MONTHLY";
    ESalaryPeriod[ESalaryPeriod["YEARLY"] = 2] = "YEARLY";
})(ESalaryPeriod || (ESalaryPeriod = {}));
var SalaryPeriodOptions = {
    vi: [
        {
            id: 1,
            name: 'Hàng tháng'
        },
        {
            id: 2,
            name: 'Hàng năm'
        }
    ],
    en: [
        {
            id: 1,
            name: 'Monthly'
        },
        {
            id: 2,
            name: 'Yearly'
        }
    ]
};

export { ESalaryPeriod, SalaryPeriodOptions, TOTAL_MAX_JOB_ALERT_CODE, duplicatedJobAlert, maxJobTitleLength, successCode };
//# sourceMappingURL=constants.js.map
